module.exports = __webpack_public_path__ + "img/Heslin.302555e2.jpg";